import React, { Component } from 'react';
import { Button, Card, Form, Table } from 'antd';
import { Link } from 'react-router';

import { queryDepartmentOpportunity } from '@api/crm/crm';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
  }

  componentWillMount() {
    this.uuid = this.props.params.uuid;
  }

  componentDidMount() {
    this.getData();
  }

  getData = () => {
    queryDepartmentOpportunity({
      uuid: this.uuid,
    }).then(res => {
      this.setState({
        data: res.data,
      });
    });
  };

  columns = () => {
    return [
      {
        title: '编号',
        dataIndex: 'uuid',
        render: (text, record, index) => {
          return <span>{index + 1}</span>;
        },
      },
      {
        title: '阶段',
        dataIndex: 'name',
      },
      {
        title: '预测百分比',
        dataIndex: 'percentage',
        render: text => <span>{`${text}%`}</span>,
      },
    ];
  };

  render() {
    const { data } = this.state;
    return (
      <Card>
        <div className="tableList">
          <div className="tableListOperator">
            <Link to={`/crm/department/${this.uuid}/stage/add`}>
              <Button type="primary">设置阶段</Button>
            </Link>
          </div>
        </div>
        <Table rowKey="index" columns={this.columns()} dataSource={data} />
      </Card>
    );
  }
}
export default Form.create({ wrappedComponentRef: true })(Index);



// WEBPACK FOOTER //
// ./src/components/crm/department/stage/Index.js